import { useTranslate } from 'react-polyglot'
import { useHistory } from 'react-router-dom'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { ExternalLinkOutlinedIcon } from '@getgo/chameleon-icons/react'
import { MenuItem, Typography } from '@getgo/chameleon-web-react-wrapper'
import { makeStyles } from '@material-ui/core'

import { GlobalSearchBarDetails, GlobalSearchBarType } from 'types/GlobalSearchBarDetails'

const useStyles = makeStyles(() => ({
  optionTypeLabel: {
    backgroundColor: tokens.interactiveColorSuccessDefault,
    padding: '1px 5px 3px 5px',
    textTransform: 'uppercase',
  },
}))

interface OptionLinkProps {
  option: GlobalSearchBarDetails
  onClickOption: (option: GlobalSearchBarDetails) => void
}

const OptionLink = ({ option, onClickOption }: OptionLinkProps): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const t = useTranslate()

  return (
    <MenuItem
      key={option.keyword}
      title={option.keyword}
      trailingIcon={
        GlobalSearchBarType.SUPPORT_ARTICLE === option.linkType ? (
          <Typography
            tag="span"
            className={classes.optionTypeLabel}
            variant="caption-small"
            color="type-color-inverted"
          >
            {t('Doc')}
          </Typography>
        ) : option.external ? (
          <ExternalLinkOutlinedIcon />
        ) : undefined
      }
      role="menuitem"
      onClick={() => {
        onClickOption(option)
        option.external ? window.open(option.to, '_blank') : history.push(option.to)
      }}
    >
      {option.keyword}
    </MenuItem>
  )
}

export default OptionLink
